import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IChallengeCertificate } from 'src/shared/models';

const {
  FORMATION_CERTIFICATE_TEMPLATE,
  FORMATION_CERTIFICATE_REQUIRED_POINTS,
} = ResourceTypeDetailEnum;

export const buildChallengeCertificate = (
  resource: IResourceList
): IChallengeCertificate => {
  const { resourceDetailList, name: title, idResource } = resource;
  let item: IChallengeCertificate;

  // ? Get values from the QUIZ_DERMO details
  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        // ? Check for an uploaded template for this Certificate
        case FORMATION_CERTIFICATE_TEMPLATE:
          item = {
            ...item,
            isCertificateTemplate: value !== '' ? true : false,
          };
          break;
        // ? Get the required minimum points to obtain the Certificate
        case FORMATION_CERTIFICATE_REQUIRED_POINTS:
          item = {
            ...item,
            requiredPoints: Number(value),
          };
          break;
      }
    });

  return {
    ...item,
    title,
    idResource,
  };
};
